import { Dispatch, ReactNode, SetStateAction, useState } from "react";
import { Image } from "primereact/image";
import { Button } from "primereact/button";
import { classNames } from "primereact/utils";

import fexdexLogo from "../../assets/images/fedex-logo.png";
import SvgShippingIcon from "./SvgShippingIcon";
import { Dialog } from "primereact/dialog";

type PropTyps = {
    icon: string;
    title: string;
    isRegular:boolean;
    isSelected: boolean;
    description: string;
    entityTypes: string[];
    equityTypes: string[];
    recommended?: boolean;
    previewImage:string;
    onSelect: Dispatch<SetStateAction<boolean>>
}

function FormTypeCard(props: PropTyps): ReactNode {

    const {
        icon,
        title,
        isRegular,
        onSelect,
        isSelected,
        description,
        entityTypes,
        equityTypes,
        recommended = false,
        previewImage
    } = props;

    const [visible, setVisible] = useState(false);

    return (
        <>
        <div className={classNames("flex flex-1 flex-column gap-2 cursor-pointer border-1 border-round-lg transition-all bg-white", {
            "border-primary": isSelected,
            "hover:border-blue-500 surface-border": !isSelected
        })} onClick={() => onSelect(isRegular)}>
            <div className="flex align-items-center justify-content-between p-4 border-bottom-1 surface-border">
                <div className="font-bold text-lg flex align-items-center gap-2">
                    <i className={classNames("pi text-2xl", icon)} />
                    <h3 className="text-xl font-semibold">{title}</h3>
                    {/* {
                        recommended ? (
                            <span className="font-semibold text-sm text-green-800 bg-green-100 border-green-300 border-1 px-2 py-1 border-round-md">
                                Recommended
                            </span>
                        ) : null
                    } */}
                </div>
                <div className="flex align-items-center gap-2 text-600 text-base font-normal">
                        <SvgShippingIcon/>
                    <span className="text-600 text-base font-normal">Ships via:</span>
                    <div className="flex gap-2">
                        <Image src={fexdexLogo} alt="shipping1" width="35" preview={false} />
                    </div>
                </div>
            </div>
            <div className="p-4 flex flex-column gap-4 h-full">
                <div className="flex-grow-1 text-lg text-color font-normal mb-2">{description}</div>
                <div className="flex-grow-1 flex flex-column gap-2">
                    <div className="text-base font-semibold">Supported entity types:</div>
                    <div className="flex flex-wrap gap-2">
                        {entityTypes.map((item, index) => (
                            <span key={item.concat(`-${index}`)} className="font-semibold text-sm text-green-800 bg-green-100 border-green-300 border-1 px-2 py-1 border-round-md">
                                {item}
                            </span>
                        ))}
                    </div>
                </div>
                <div className="flex-grow-1 flex flex-column gap-2">
                    <div className="text-base font-semibold">Supported equity types:</div>
                    <div className="flex flex-wrap gap-2">
                        {
                            equityTypes.map((item, index) => {
                                return (
                                    <span key={item.concat(`-${index}`)} className="font-semibold text-sm text-yellow-800 bg-yellow-100 border-yellow-300 border-1 px-2 py-1 border-round-md">
                                        {item}
                                    </span>
                                )
                            })
                        }
                    </div>
                </div>                
                <div className="flex-grow-1 mt-auto">
                    <Button
                        text
                        size="small"
                        icon="pi pi-eye"
                        label="Preview Sample Form"
                        onClick={() => setVisible(true)} 
                    />
                </div>
            </div>
        </div>
   
            <Dialog
                header={`Preview: ${isRegular ? "Freeform Statement": "Form 15620"}`}
                visible={visible}
                style={{ width: "60vw" }}
                onHide={() => setVisible(false)}
                modal
            >
                <img
                    src={previewImage}
                    alt={isRegular ? "Freeform Statement" : "Form 15620" }
                    className="w-full border-round"
                />
            </Dialog>
        </>
    )
}

export default FormTypeCard;